import React, { CSSProperties, FC } from 'react';
import clsx from 'clsx';

import { AnimatedButton } from '../../common';
import './SuggestionChip.scss';

interface SuggestionChipProps {
  emoji?: string;
  label: string;
  onPress: () => void;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * Single-line "emoji + label" pill, click-to-send-prompt — matches the v4
 * Figma "Suggestions" chip list (e.g. "📅  Focus Sprint").
 */
const SuggestionChip: FC<SuggestionChipProps> = ({
  emoji,
  label,
  onPress,
  disabled,
  className,
  style,
}) => (
  <AnimatedButton
    onPress={onPress}
    disabled={disabled}
    fullWidth={false}
    className={clsx('suggestion-chip', className)}
    style={style}
  >
    <span className="suggestion-chip__label">{emoji ? `${emoji}  ${label}` : label}</span>
  </AnimatedButton>
);

export default SuggestionChip;
